import Dexie from "dexie";
import db from "../Db";

var UpdatePhotoconc = Dexie.async(function* (PHOTOCONC) {
  yield db.open();
  yield db.PHOTOCONC.put(PHOTOCONC);
});

export default UpdatePhotoconc;
